import axios from 'axios';

const apiBase = () => process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000/api';

/**
 * Features resolved by the backend for the calling user.
 *
 * Deliberately NOT on `axiosInstance`: its 401 interceptor clears the session and
 * redirects to /login. This runs as an unattended background poll (on focus and
 * on a timer), so routing it through that interceptor would throw a student with
 * an expired token straight out of a tab they had merely left open. A background
 * refresh must never be able to log anyone out — the next foreground request
 * will surface the expired session on its own terms.
 *
 * The response carries only keys that evaluate true — an un-launched feature's
 * existence is not disclosed — so any absent key means "disabled".
 *
 * @returns {Promise<Record<string, boolean>>}
 */
export async function getMyFeatures() {
  const token = localStorage.getItem('token');
  const { data } = await axios.get(`${apiBase()}/features/me`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });

  // A 200 whose body is not the expected envelope (proxy interstitial, HTML
  // error page, an envelope change) must not read as "every feature is off" —
  // that is indistinguishable from a real withdrawal and would silently strip
  // capabilities from every extension.
  const features = data?.data;
  if (!features || typeof features !== 'object' || Array.isArray(features)) {
    throw new Error('features response was not in the expected shape');
  }
  return features;
}
